const Founders = () => {
	return (
		<div className="flex justify-center gap-16" id="aboutus">
			<div className="absolute h-full max-h-[780px] min-h-[375] w-screen bg-[#5AE0D7] sm:max-h-[616px]" />
			<div className="relative -top-16 mx-8 w-full space-y-10 rounded-[16px] bg-white p-8 shadow-custom lg:mx-0 lg:w-[522px]">
				<h2 className="text-center text-3xl font-bold">Kdo stojí za Notify</h2>
				<img src="img/founders-profile.webp" alt="founders" />
				<p>
					Filip Tabáček CEO marketingové agentury Avedeo <br />
					<span className="italic">
						„Za 7 let, které jsem věnoval marketingu pro e-shopy jsem zjistil co
						e-shopy chtějí a potřebují. Proto jsem se spojil s Honzou, který se
						svým týmem vytvořili jedinečné řešení, které vám umožní vydělat více
						peněz a být blíže se zákazníky.“
					</span>
				</p>
				<p>
					Jan Netolička, Co-Founder IT agentury Blaze Codes <br />
					<span className="italic">
						„Když mě Filip oslovil s nápadem, jak pomoci e-shopům vyrůst pomocí
						mobilní aplikace, neváhal jsem ani minutu. Nápad jsem nadchnul i
						zbytek firmy a dali jsme se do práce. Při vývoji jsme se soustředili
						primárně na spolehlivost řešení a jednoduché, intuitivní uživatelské
						prostředí.“
					</span>
				</p>
			</div>
			<img
				src="img/founders-office.webp"
				alt="team"
				className="relative -top-16 hidden rounded-[16px] lg:block"
				width={522}
				height={744}
			/>
		</div>
	)
}

export default Founders
